import { PageController } from '@client/components/_core/layout/PageController';
import { LlmStatsView } from '@client/components/admin/llm-stats/LlmStatsView';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

export const Route = createFileRoute('/admin-console/monitoring/llm-stats')({
    staticData: {
        permissions: ['admin_ai:read'],
        breadcrumb: {
            title: 'LLM statistics',
        },
        ui: {
            icon: BarChart3,
            title: 'LLM statistics',
            subtitle: 'View aggregated LLM usage statistics and costs',
            widthVariant: 'fullWidth',
            menuDescription: 'LLM usage analytics and cost tracking',
        },
    },
    component: LlmStatsPage,
});

function LlmStatsPage() {
    return (
        <PageController route={Route}>
            <LlmStatsView />
        </PageController>
    );
}
